import axios from 'axios'

class MaterialsQueries {
    // Materials
    fetchMaterials(params) {
        return axios.get('/materials/materials', { params })
    }

    fetchMaterial(materialId) {
        return axios.get(`/materials/materials/${materialId}`)
    }

    createMaterial(payload) {
        return axios.post('/materials/materials', payload)
    }

    updateMaterial(materialId, payload) {
        return axios.put(`/materials/materials/${materialId}`, payload)
    }

    fetchUnitsOfMeasure() {
        return axios.get('/materials/materials/dicts/units-of-measure')
    }

    fetchMaterialTypes(params) {
        return axios.get('/materials/material-types', { params })
    }

    updateMaterialType(materialTypeId, payload) {
        return axios.patch(`/materials/material-types/${materialTypeId}`, payload)
    }

    fetchProductProductionProperties(params) {
        return axios.get('/products/product-production-properties', { params })
    }

    generateMaterialsPriceList(config = {}) {
        return axios.post('/materials/export-materials', null, { ...config })
    }

    importMaterialsPriceList(formData, { signal, onUploadProgress } = {}) {
        return axios.post('/materials/import-materials', formData, {
            signal,
            onUploadProgress
        })
    }

    // Paper groups
    fetchPaperGroups(params) {
        return axios.get('/papers/paper-groups', { params })
    }

    createPaperGroup(payload) {
        return axios.post('/papers/paper-groups', payload)
    }

    updatePaperGroup(paperGroupId, payload) {
        return axios.put(`/papers/paper-groups/${paperGroupId}`, payload)
    }

    // Papers
    fetchPapers(params) {
        return axios.get('/papers/papers', { params })
    }

    fetchPaper(paperId) {
        return axios.get(`/papers/papers/${paperId}`)
    }

    createPaper(payload) {
        return axios.post('/papers/papers', payload)
    }

    updatePaper(paperId, payload) {
        return axios.put(`/papers/papers/${paperId}`, payload)
    }

    fetchCoatingTypes() {
        return axios.get('/papers/papers/dicts/paper-coating-types')
    }

    fetchPrinergyPaperTypes() {
        return axios.get('/papers/papers/dicts/prinergy-paper-types')
    }

    fetchPaperCertificates(params) {
        return axios.get('/papers/papers/dicts/paper-certificates', { params })
    }

    generatePapersPriceList(config = {}) {
        return axios.post('/papers/export-papers', null, { ...config })
    }

    importPapersPriceList(formData) {
        return axios.post('/papers/import-papers', formData, {})
    }

    // PMS types
    fetchMaterialsPmsTypes() {
        return axios.get('/materials/pms-types')
    }
}

export default new MaterialsQueries()
